// extracted by mini-css-extract-plugin
export default {"cardsList":"hHW8w9UD"};